// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const H4OutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 640 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M455.5 92.9l-34 163.1H592V88c0-13.3 10.7-24 24-24s24 10.7 24 24v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V304H392c-7.2 0-14.1-3.3-18.6-8.9s-6.3-13-4.9-20l40-192c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4zM24 64c13.3 0 24 10.7 24 24v136h224V88c0-13.3 10.7-24 24-24s24 10.7 24 24v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H48v152c0 13.3-10.7 24-24 24S0 437.3 0 424V88c0-13.3 10.7-24 24-24z"}}]},"name":"h4","theme":"outlined"};

const H4Outlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={H4OutlinedSvg} />;
  H4Outlined.displayName = 'H4Outlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(H4Outlined);
